<script>
import {FormContextKey} from 'vee-validate'
import {v4 as uuidv4, validate as isUuid} from "uuid";
import symbols from "@core/util/symbols";

export default {
    name: "NestedForm",
    provide() {
        return {
            [symbols.nestingFormKey]: (this.parentUuid ? this.parentUuid + '.' : '') + this.uuid
        }
    },
    inject: {parentValidator: {from: FormContextKey}, parentUuid: {from: symbols.nestingFormKey, default: null}},
    data() {
        return {
            uuid: uuidv4(),
            valid: false,
            validating: false
        }
    },
    computed: {
        pathId() {
            return this.parentUuid ? this.parentUuid + '.' + this.uuid : this.uuid
        },
        nestedValidator() {
            const nestedErrors = {}

            if (this.parentValidator?.errors?.value) {
                for (const error of Object.keys(this.parentValidator.errors.value)) {
                    if (error.includes(this.uuid)) {
                        nestedErrors[error] = this.parentValidator.errors.value[error]
                    }
                }
            }

            return {
                ...this.parentValidator,
                errors: nestedErrors,
                validate: this.validate,
                meta: {
                    ...this.parentValidator.meta,
                    valid: this.valid
                }
            }
        }
    },
    methods: {
        async validate(opts = {}) {
            if (this.validating) return this.valid
            this.validating = true
            try {
                this.valid = await this.validateLevel(this.parentValidator.controlledValues.value[this.pathId] ?? {}, opts)
            } catch (e) {
                this.valid = false
            }
            this.validating = false
            return this.valid
        },
        async validateLevel(level, opts, path = '') {
            return (await Promise.all(Object.keys(level).map(async field => {
                if (isUuid(field)) return await this.validateLevel(level[field], opts, (path.length ? path + '.' : '') + field)
                const validationResult = (await this.parentValidator.validateField(this.pathId + '.' + (path.length ? path + '.' : '') + field, opts))
                return validationResult?.valid
            }))).every(v => v)
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.validate({mode: 'silent'})
        })
    },
    beforeUnmount() {
        this.parentValidator.destroyPath(this.pathId)
    },
    watch: {
        'parentValidator.errors': {
            handler() {
                // TODO test in develop
                this.validate({mode: 'silent'})
            },
            deep: true
        }
    }
}
</script>

<template>
    <VForm
        v-slot="validation"
        keep-values
        v-bind="$attrs">
        <NestedFormOverwrite
            :parent-validator="parentValidator"
            :nested-validation="validation">
            <slot v-bind="nestedValidator" />
        </NestedFormOverwrite>
    </VForm>
</template>

<style scoped>

</style>
